import React, { useState } from "react"
import Card from "./Card"
import OneResource from "./OneResource"

/**
 * @param props {{
 * scState:scState
 * }  }
 */
export default function LeftSizeResourceList({ scState }) {
  var objects = []

  objects =
    scState.json.tabsObject[scState.selectedResourseType]?.elements || []

  return (
    <div
      css={`
        margin-top: 6px;
      `}
    >
      <Card topIsSquare>
        {objects.map((x) => (
          <div
            key={x.astId || x.displayName}
            css="display:inline-block;margin-bottom:5px;margin-right:5px;"
          >
            <OneResource scState={scState} resource={x} />
          </div>
        ))}
      </Card>
    </div>
  )
}
